import React from 'react';
import {
  FormatListBulleted as WorklistIcon,
  FactCheck as ReviewQueueIcon,
  CheckCircle as ReadinessIcon,
  ShoppingCart as OrdersIcon,
  Science as ProtocolsIcon,
  Groups as SurgeonsIcon,
  Settings as SettingsIcon,
  AdminPanelSettings as AdminIcon,
  Person as ProfileIcon,
} from '@mui/icons-material';

export const getWorkbenchNavItems = (isASC) => {
  if (isASC) {
    return [
      {
        key: 'worklist',
        label: 'Worklist',
        path: '/asc/patient-management',
        icon: <WorklistIcon fontSize="small" />,
      },
      {
        key: 'review-queue',
        label: 'Review Queue',
        path: '/asc/review-queue',
        icon: <ReviewQueueIcon fontSize="small" />,
      },
      {
        key: 'readiness',
        label: 'Readiness',
        path: '/asc/readiness',
        icon: <ReadinessIcon fontSize="small" />,
      },
      {
        key: 'orders',
        label: 'Orders',
        path: '/asc/orders',
        icon: <OrdersIcon fontSize="small" />,
      },
      {
        key: 'protocols',
        label: 'Protocols',
        path: '/asc/protocol-management',
        icon: <ProtocolsIcon fontSize="small" />,
      },
      {
        key: 'surgeons',
        label: 'Surgeons',
        path: '/asc/surgeon-management',
        icon: <SurgeonsIcon fontSize="small" />,
      },
      {
        key: 'settings',
        label: 'Settings',
        path: '/asc/settings',
        icon: <SettingsIcon fontSize="small" />,
      },
      {
        key: 'profile',
        label: 'Profile',
        path: '/asc/profile',
        icon: <ProfileIcon fontSize="small" />,
      },
      {
        key: 'admin',
        label: 'Admin',
        path: '/asc/admin',
        icon: <AdminIcon fontSize="small" />,
      },
    ];
  }

  return [
    {
      key: 'worklist',
      label: 'Worklist',
      path: '/patient-management',
      icon: <WorklistIcon fontSize="small" />,
    },
    {
      key: 'review-queue',
      label: 'Review Queue',
      path: '/review-queue',
      icon: <ReviewQueueIcon fontSize="small" />,
    },
    {
      key: 'readiness',
      label: 'Readiness',
      path: '/readiness',
      icon: <ReadinessIcon fontSize="small" />,
    },
    {
      key: 'orders',
      label: 'Orders',
      path: '/orders',
      icon: <OrdersIcon fontSize="small" />,
    },
    {
      key: 'protocols',
      label: 'Protocols',
      path: '/protocols',
      icon: <ProtocolsIcon fontSize="small" />,
    },
    {
      key: 'surgeons',
      label: 'Surgeons',
      path: '/surgeons',
      icon: <SurgeonsIcon fontSize="small" />,
    },
    {
      key: 'settings',
      label: 'Settings',
      path: '/settings',
      icon: <SettingsIcon fontSize="small" />,
    },
    {
      key: 'profile',
      label: 'Profile',
      path: '/profile',
      icon: <ProfileIcon fontSize="small" />,
    },
    {
      key: 'admin',
      label: 'Admin',
      path: '/admin',
      icon: <AdminIcon fontSize="small" />,
    },
  ];
};
